import { Widget, WIDGET_RESOLVED_MARKETS, TimeoutEvent, ChannelSwitchEvent } from "@gaming/srvg-classes-core";


export class ResolvedMarketsWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {
        options = options || {};
        options.selector = options.selector || '#resolvedMarketsWidget';
        super( options );

        this.name = 'widgetresolvedmarkets';
        this.widgetName = options.widgetName || WIDGET_RESOLVED_MARKETS;
        this.widgetName = this.product + this.widgetName;

        this.widget = null;

        if (options.selectedChannel){
            this.widgetOptions = {
                selectedChannel: options.selectedChannel
            };
        }else{
            this.widgetOptions = {
                selectedChannel: srvg.videooptions.defaultchannel || 0,
            };
        }

        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addResolvedMarketsWidget();
        super.handleDomInstantiated();
    }

    /**
     * add livescore widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addResolvedMarketsWidget(selector?) {
        selector = selector || this.selector;

        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

    /**
     * add specific widget will be called by events for example, prepares eventdata and calls addLivescoreWidget
     * @param string selector
     * @param object/any eventdata
     */
    addSpecificWidget(selector, eventdata){
        this.addResolvedMarketsWidget(selector);
    }

    /**
     * calls widget api setChannel to switch channel
     * it is not necessary to switch the channel if livescore widget is connected with widget via widget group
     * @param number channel equivalent to videochannel
     */
    setChannel(channel?: number){
        if(this.widget.api && typeof this.widget.api.setChannel === "function"){
            this.widget.api.setChannel(channel);
        }
    }

    // destroy the widget for inactivity
    handleTimeoutEvent(event: TimeoutEvent, provider){
        this.destroyWidget(this.widget, this.name);
    }

    handleChannelSwitchEvent(event: ChannelSwitchEvent, provider){
        this.widgetOptions.selectedChannel = event.newChannel;
        this.setChannel(event.newChannel);
    }
}
